const basePath = 'passenger_app/v1/ticketing/buyer_registry'

export default {
  async show() {
    const response = await Vue.http.get(basePath)
    return response.data.data
  },

  async validate(params) {
    const response = await Vue.http.get(`${basePath}/validate`, {params})
    return response.data.data
  },

  async update(data) {
    const response = await Vue.http.put(basePath, {data})
    return response.data
  }
}
